import { formatStringLowercaseWithDashes } from 'shared/utils/formatStringLowercaseWithDashes';
import { normalizeValue } from 'shared/utils/normalizeValue';

export const formatString = (str: string) => formatStringLowercaseWithDashes(normalizeValue(str));
